export const locales = ['ru', 'kk', 'en'] as const;
export type Locale = typeof locales[number];

// kz — исторический синоним kk, встречается в уже разосланных ссылках
const localeAliases: Record<string, Locale> = {ru: 'ru', kk: 'kk', kz: 'kk', en: 'en'};

// Перечисление для path-сегмента: используется и в маршрутах vue-router, и в regexp ниже
export const localeUrlPattern = 'ru|kk|kz|en';

const localeSegmentRe = new RegExp(`^/(?:promocode/[^/]+/)?(${localeUrlPattern})/?$`);

export function normalizeLocale(value: string | null | undefined): Locale | null {
    return (value && localeAliases[value]) || null;
}

/**
 * Язык, заданный в URL, в двух формах:
 *   * ?lang=kk — старая, поддерживается по-прежнему и имеет приоритет;
 *   * сегмент пути /kk и /promocode/CODE/kk — новая, её предпочитаем при шаринге,
 *     потому что query-строку краулеры мессенджеров и CDN не кэшируют.
 * Те же правила продублированы в nginx (default.conf) для og-мета — меняйте вместе.
 */
export function localeFromUrl(pathname: string, search: string): Locale | null {
    const fromQuery = normalizeLocale(new URLSearchParams(search).get('lang'));
    if (fromQuery) return fromQuery;

    return normalizeLocale(pathname.match(localeSegmentRe)?.[1]);
}
